import { notification } from 'antd'
import './style.scss'

notification.config({
  placement: 'bottomRight',
  duration: 3,
})

export const notify = {
  success: (message: string, description?: string) => {
    notification.success({
      message,
      description,
      className: 'notification-custom-success',
    })
  },
  error: (message: string, description?: string) => {
    notification.error({
      message,
      description,
      className: 'notification-custom-error',
    })
  },
  info: (message: string, description?: string) => {
    notification.info({
      message,
      description,
      className: 'notification-custom-info',
    })
  },
  warning: (message: string, description?: string) => {
    notification.warning({
      message,
      description,
      className: 'notification-custom-warning',
    })
  },
}
